import { createReducer } from '@lib/plugin-redux-core';
import { gradingSubmissionHandlers } from './grading-submission.handler';
import { GradingSubmissionInitialState } from './grading-submission.states';

const initialState: GradingSubmissionInitialState = {
  error: null,
};

export const gradingSubmissionReducer = createReducer(initialState, [...gradingSubmissionHandlers]);
